import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { get_Single_NewCompany, get_NewCompany } from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";
import { toBeChecked } from "@testing-library/jest-dom/matchers";


const AddCompany = () => {
  const dispatch = useDispatch();
  const TransactionData = useSelector(
    (state) => state.feedBackReducer.Addcompanydata
  );

  const TransactionData2 = useSelector(
    (state) => state.feedBackReducer.newcompdata
  );



  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [DregeeID, setDregeeID] = useState("");
  const [loading, setLoading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    TransactionType: "",
    Category: "",
    CreatedByUser: "1",
    IsActive: "1",
    Companyname: "",
    Tds: "",
    PlateFormchargePer: "",
    GSTNo: "",
    Address: "",
    MobileNo: "",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Category: "", TransactionType: "" });
  };




  useEffect(() => {
    if (IsActive) {
      dispatch(get_Single_NewCompany(null, setLoading));
    } else {
      dispatch(get_Single_NewCompany(null, setLoading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
  
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        Companyname: EditValue[0]?.CompanyName,
        Tds: EditValue[0]?.TDS,
        PlateFormchargePer: EditValue[0]?.PlateFormchargePer,
        GSTNo: EditValue[0]?.GSTNo,
        Address: EditValue[0]?.Address,
        MobileNo: EditValue[0]?.MobileNo,

      });
    }
    else {
      setaddFormData({
        ...addFormData,
        Companyname: "",
        Tds: "",
        PlateFormchargePer: "",
        GSTNo: "",
        Address: "",
        MobileNo: "",

      });
    }
  }, [EditValue]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";


    const trimcompanyname = addFormData.Companyname?.trim();
    const trimmedtds = addFormData.Tds?.trim() || "";
    const trimmedplatformcharge = addFormData.PlateFormchargePer?.trim() || "";
    const trimgstno = addFormData.GSTNo?.trim() || "";
    if (!trimcompanyname) {
      error = true;
      errorMsg = "Please fill Company name.";
    }

    if (!trimmedtds) {
      error = true;
      errorMsg = "Please fill TDS.";
    }
    if (!trimmedplatformcharge) {
      error = true;
      errorMsg = "Please fill Platform Charge";
    }

    if (!trimgstno) {
      error = true;
      errorMsg = "Please fill GST No";
    }

    if (!error) {
      const insertdata = {

        Companyname: addFormData.Companyname,
        Tds: addFormData.Tds,
        PlateFormchargePer: addFormData.PlateFormchargePer,
        GSTNo: addFormData.GSTNo,
        Address: addFormData.Address,
        MobileNo: addFormData.MobileNo,

      };


      await AddUpdate("CompanyTransaction/Insert_Company", insertdata);
      setPostModal(false);
      dispatch(get_Single_NewCompany(null, setLoading));
      swal("Good job!", "Successfully Added", "success");
      Reset();
      setaddFormData({ Category: "", TransactionType: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };



  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    const trimcompanyname = addFormData.Companyname?.trim();
    const trimmedtds = addFormData.Tds?.trim() || "";
    const trimmedplatformcharge = addFormData.PlateFormchargePer?.trim() || "";
    const trimgstno = addFormData.GSTNo?.trim() || "";
    if (!trimcompanyname) {
      error = true;
      errorMsg = "Please fill Company name.";
    }

    if (!trimmedtds) {
      error = true;
      errorMsg = "Please fill TDS.";
    }
    if (!trimmedplatformcharge) {
      error = true;
      errorMsg = "Please fill Platform Charge";
    }

    if (!trimgstno) {
      error = true;
      errorMsg = "Please fill GST No";
    }
    if (!error) {
      const updatedata = {
        CompanyID: DregeeID,
        Companyname: addFormData.Companyname,
        Tds: addFormData.Tds,
        PlateFormchargePer: addFormData.PlateFormchargePer,
        GSTNo: addFormData.GSTNo,
        Address: addFormData.Address,
        MobileNo: addFormData.MobileNo,
      };
      await AddUpdate(
        "CompanyTransaction/Update_Company",
        updatedata
      );
      setEditModal(false);
      dispatch(get_Single_NewCompany(null, setLoading));
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Category: "", TransactionType: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };


  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {


    dispatch(get_NewCompany(row?.CompanyID, setLoading));
    setDregeeID(row?.CompanyID);

    setEditModal(true);
  };
  useEffect(() => {


    if (TransactionData2) {
      setEditValue(TransactionData2);
    }
  }, [TransactionData2]);

  const columns = [
    {
      name: "Company Name",
      selector: (row) => row.CompanyName,
      sortable: true,
    },
    {
      name: "Gst No",
      selector: (row) => row.GSTNo,
      sortable: true,
    },
    {
      name: "Platform charge",
      selector: (row) => row.PlateFormchargePer,
      sortable: true,
    },
    {
      name: "TDS ",
      selector: (row) => row.TDS,
      sortable: true,
    },
    {
      name: "Mobile No ",
      selector: (row) => row.MobileNo,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.Address,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-success" : "text-danger"}
                onClick={() => {
                  handleToggleStatusClick(row.CompanyID, true, "0");
                }}
              >
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];



  const handleToggleStatusClick = async (
    DregeeID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      CompanyID: DregeeID,
    };

    await AddUpdate("CompanyTransaction/Delete_Company", postData);
    dispatch(get_Single_NewCompany(null, setLoading));
    swal(
      "Good job!",
      `Successfully Deleted`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="main_card">
          <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap ">
            <div className="card-action coin-tabs">
              <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Add Company</h2>
            </div>
            <Link
              to={"#"}
              className="btn btn-primary font-w600 "
              onClick={() => {
                setEditValue([]);
                setPostModal(true);
                Reset();
              }}
            >
              + New Company
            </Link>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="">
                <div className=" p-0">
                  <Tab.Content>
                    <Tab.Pane eventKey="All">
                      <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                        <Modal
                          className="modal fade"
                          show={postModal}
                          onHide={() => setPostModal(false)}
                          backdrop="static"
                        >
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Add New Company
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setPostModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>



                              <div className="add-contact-box">

                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label className="form-label">
                                      Company Name
                                    </label>
                                    <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    name="Companyname"
                                    value={addFormData?.Companyname || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter company name"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="add-contact-box">

                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label className="form-label">
                                      TDS
                                    </label>
                                    <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="number"
                                    // className="form-control"
                                    name="Tds"
                                    value={addFormData?.Tds || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter TDS"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="add-contact-box">

                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label className="form-label">
                                      Platform Charge
                                    </label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="number"
                                    // className="form-control"
                                    name="PlateFormchargePer"
                                    value={addFormData?.PlateFormchargePer || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter platform charge"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="add-contact-box">

                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label className="form-label">
                                      Gst Number
                                    </label>
                                    <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="number"
                                    // className="form-control"
                                    name="GSTNo"
                                    value={addFormData?.GSTNo || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter Gst number"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="add-contact-box">

                                <div className="form-group">
                                  <label className="form-label">
                                    Mobile No
                                  </label>
                                  {/* <span className="text-danger star-error">
                                  *
                                </span> */}
                                  <input
                                    type="number"
                                    // className="form-control"
                                    name="MobileNo"
                                    value={addFormData?.MobileNo || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter MobileNo"
                                    required
                                  />
                                </div>
                              </div>

                              <div className="add-contact-box">

                                <div className="form-group">
                                  <label className="form-label">
                                    Address
                                  </label>
                                  {/* <span className="text-danger star-error">
                                  *
                                </span> */}
                                  <input
                                    type="text"
                                    // className="form-control"
                                    name="Address"
                                    value={addFormData?.Address || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter Address"
                                    required
                                  />
                                </div>
                              </div>





                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={handleAddFormSubmit}
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setPostModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </Modal>
                      </div>
                      <Modal
                        className="modal fade "
                        show={editModal}
                        onHide={setEditModal}
                        backdrop="static"
                      >
                        <div className="" role="document">
                          <div className="">
                            <form>
                              <div className="modal-header">
                                <h4 className="modal-title fs-20">
                                  Edit Company
                                </h4>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setEditModal(false)}
                                  data-dismiss="modal"
                                ></button>
                              </div>

                              <div className="modal-body p-3">
                                <i
                                  className="flaticon-cancel-12 close"
                                  data-dismiss="modal"
                                ></i>
                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label className="form-label">
                                        Company Name
                                      </label>
                                      <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                        *
                                      </span>
                                    </div>
                                    <input
                                      type="text"
                                      // className="form-control"
                                      name="Companyname"
                                      value={addFormData?.Companyname || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter company name"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label className="form-label">
                                        TDS
                                      </label>
                                      <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                        *
                                      </span>
                                    </div>
                                    <input
                                      type="number"
                                      // className="form-control"
                                      name="Tds"
                                      value={addFormData?.Tds || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter TDS"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label className="form-label">
                                        Platform Charge
                                      </label>
                                      <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                        *
                                      </span>
                                    </div>
                                    <input
                                      type="number"
                                      // className="form-control"
                                      name="PlateFormchargePer"
                                      value={addFormData?.PlateFormchargePer || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter platform charge"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                      <label className="form-label">
                                        Gst Number
                                      </label>
                                      <span style={{ marginTop: "-5px" }} className="text-danger star-error" >
                                        *
                                      </span>
                                    </div>
                                    <input
                                      type="number"
                                      className="form-control"
                                      name="GSTNo"
                                      value={addFormData?.GSTNo || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter Gst number"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <label className="form-label">
                                      Mobile No
                                    </label>
                                    {/* <span className="text-danger star-error">
                                 *
                               </span> */}
                                    <input
                                      type="number"
                                      // className="form-control"
                                      name="MobileNo"
                                      value={addFormData?.MobileNo || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter MobileNo"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="add-contact-box">

                                  <div className="form-group">
                                    <label className="form-label">
                                      Address
                                    </label>
                                    {/* <span className="text-danger star-error">
                                 *
                               </span> */}
                                    <input
                                      type="text"
                                      // className="form-control"
                                      name="Address"
                                      value={addFormData?.Address || ""}
                                      onChange={handleAddFormChange
                                      }
                                      placeholder="Enter Address"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="modal-footer">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  onClick={UpdateSlider}
                                >
                                  Update
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditModal(false);
                                    Reset();

                                  }}
                                  className="btn btn-danger"
                                >
                                  {" "}
                                  <i className="flaticon-delete-1"></i> Close
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </Modal>
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={TransactionData}
                            columns={columns}
                            selectableRowsHighlight
                            //   pagination
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                    </Tab.Pane>

                  </Tab.Content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default AddCompany;
